import Home from "./home";
import NotFound from "./notFound";

import ProfilePage from "./profile";
import RevenuePage from "./revenues";
import RevenueReport from "./revenues/report";
import Statistical from "./revenues/Statistical";
import CreateStatistical from "./revenues/CreateStatistical";
import EditStatistical from "./revenues/EditStatistical";
import SystemPage from "./system";
import SystemConfiguration from "./system/SystemConfiguration";
import LimitCheckErrCodePackage from "./system/LimitCheckErrCodePackage";

import AuthPage from "./auth";
import LoginPage from "./auth/login";

import Dashbooard from "./dashbooard";

import TransactionOverview from "./Transactions/TransactionOverview";
import TransactionRetry from "./Transactions/TransactionRetry";

import Packages from './packages'
import CreatePackagesSponsor from './packages/CreatePackagesSponsor'
import CreatePackagesCode from './packages/CreatePackagesCode'
import EditPackagesSponsor from "./packages/EditPackagesSponsor"
import EditPackagesCode from "./packages/EditPackagesCode"

import PartnerManagement from "./Partners/PartnerManagement";
import PackageManagement from "./Partners/PackageManagement";
import CreatePartnerSponsor from "./Partners/CreatePartnerSponsor";
import CreatePartnerSponsorPromotion from "./Partners/CreatePartnerSponsorPromotion";
import CreatePartnerCode from "./Partners/CreatePartnerCode";
import EditPartnerSponsor from "./Partners/EditPartnerSponsor";
import EditPartnerSponsorPromotion from "./Partners/EditPartnerSponsorPromotion";
import EditPartnerCode from "./Partners/EditPartnerCode";

import PartnerList from "./AccountManagement/PartnerList";
import CreatePartner from "./AccountManagement/CreatePartner";
import EditPartner from "./AccountManagement/EditPartner";
import ProviderList from "./AccountManagement/ProviderList";
import CreateNetworkProvider from "./AccountManagement/CreateNetworkProvider";
import EditNetworkProvider from "./AccountManagement/EditNetworkProvider";
import CreateVDSProvider from "./AccountManagement/CreateVDSProvider";
import EditVDSProvider from "./AccountManagement/EditVDSProvider";
import CreateIrisProvider from "./AccountManagement/CreateIrisProvider";
import EditIrisProvider from "./AccountManagement/EditIrisProvider";
import CreateTDMProvider from "./AccountManagement/CreateTDMProvider";
import EditTDMProvider from "./AccountManagement/EditTDMProvider";

import TransactionReports from "./ReportsAnalytics/TransactionReports";
import AuditTrailExport from "./ReportsAnalytics/AuditTrailExport";
import DataSponsorStatistics from "./ReportsAnalytics/DataSponsorStatistics";

export {
  NotFound,
  Home,
  AuthPage,
  LoginPage,
  ProfilePage,
  RevenuePage,
  RevenueReport,
  Statistical,
  CreateStatistical,
  EditStatistical,
  SystemPage,
  SystemConfiguration,
  LimitCheckErrCodePackage,

  Dashbooard,

  TransactionOverview,
  TransactionRetry,

  Packages,
  CreatePackagesSponsor,
  CreatePackagesCode,
  EditPackagesSponsor,
  EditPackagesCode,

  PartnerManagement,
  PackageManagement,
  CreatePartnerSponsor,
  CreatePartnerSponsorPromotion,
  CreatePartnerCode,
  EditPartnerSponsor,
  EditPartnerSponsorPromotion,
  EditPartnerCode,

  PartnerList,
  CreatePartner,
  EditPartner,
  ProviderList,
  CreateNetworkProvider,
  EditNetworkProvider,
  CreateVDSProvider,
  EditVDSProvider,
  CreateIrisProvider,
  EditIrisProvider,
  CreateTDMProvider,
  EditTDMProvider,

  TransactionReports,
  AuditTrailExport,
  DataSponsorStatistics,
};
